import moment from 'moment';
import { JobFormSubmission } from '../JobFormSubmission';
import { InventoryReceipt } from './InventoryReceipt';
export class ActualStop {
    constructor(json) {
        this.id = json.id;
        this.inventoryReceipts = json.inventory_receipts.map((r) => new InventoryReceipt(r));
        this.locationId = json.location_id;
        this.locationName = json.location_name;
        this.stopType = json.stop_type;
        this.occurredAt = moment.utc(json.occurred_at).local();
        this.arrivedAt = moment.utc(json.arrived_at).local();
        this.requestedStopId = json.requested_stop_id ?? null;
        this.formSubmissions = json.form_submissions.map((fs) => new JobFormSubmission(fs));
        this.createdBy = json.created_by;
    }
    get isSkipped() {
        return this.locationId == null;
    }
}
//# sourceMappingURL=ActualStop.js.map